export default __webpack_public_path__ + "static/media/estimasi-ongkir.b077d476.svg";